import { Row, Col, Button, Modal, Radio, Spin, Form, Space, Input, Card, message, Tag } from 'antd';
import { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";

// import PicAddButton from './components/PicAddButton';
// import WordPictureModal from '../components/WordPictureModal';
// import LuzCard from './components/LuzCard';
// import WYSIWYGModal from '../components/WYSIWYGModal';
// import MarkModal from '../components/MarkModal';
// import IconPictureModal from '../../IconPictureModal';
// import PictureMarkModal from '../components/PictureMarkModal';
// import PictureModal from '../components/PictureModal';
// import IconModal from '../components/IconModal';
// import CardModal from '../components/CardModal';
import axios from "axios";
import { lazy } from 'react';
import { Suspense } from 'react';
import EMILayout from './components/EMILayout'
import Carousel_news_ticker from './components/Carousel_news_ticker';
import Marquee from 'react-fast-marquee';
import { NotificationFilled } from '@ant-design/icons';

const MainPage = (
    {
        prefixTitle = '',
        title = '首頁'
    }
    // permissionId = 33,
) => {
    const [blogTypeData, setBlogTypeData] = useState([])
    const [add_modal, set_add_modal] = useState(false)
    const [component_number, set_component_number] = useState(1)
    const [restart, setRestart] = useState('false')
    const [loading, setLoading] = useState(false)
    // const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const [pageContainerData, setPageContainerData] = useState([]);
    const [permissionData, setPermissionData] = useState({});


    useEffect(() => {
        // console.log(title)
        // if (title) {
        document.title = `${prefixTitle} | ${title}`
        setPageContainerData([])
        axios
            .get(`/dynamicWebsite/frontend/permission`, {
                params: {
                    classify_structure_id: 5,
                    name: title,
                    // permission_id: 122,
                    cur_page: 1,
                    size: 10,
                }
            })

            .then((response) => {
                if (response?.data.data.length !== 0) {
                    let data = response.data?.data
                    let firstData = data.find(_ => true)
                    setPermissionData(firstData)
                    let frontend_component_blog_type_data = firstData?.frontend_component_blog_type_data
                    setPageContainerData(frontend_component_blog_type_data)
                }
            })
        // }
    }, [title])

    const componentRender = (component_name, blogTypeData) => {
        const Component = lazy(() => import(`./components/${component_name}`))
        // console.log(blogTypeData)
        if (blogTypeData.length !== 0) {
            return (
                <Suspense fallback={<></>}>
                    <Component
                        blogTypeData={blogTypeData}
                    />
                </Suspense>
            )
        }
        else {
            return (
                <Suspense fallback={<></>}>
                    <Component
                    // blogTypeData={blogTypeData}
                    />
                </Suspense>
            )
        }
    }
    const marquee_color = {
        r: 255,
        g: 255,
        b: 255,
        a: 255,
    }
    const marquee_text = "123123"
    const marquee_speed = 50
    return (
        <>
            {loading ?
                <>
                    <Spin />
                </>
                :
                <>
                    {/* <EMILayout> */}
                    <Row justify={'center'} gutter={[8, 16]} style={{ paddingBottom: "20px" }}>
                        {permissionData?.show == 1 && <>
                            <Col span={24}>
                                <Row
                                    justify={'center'}
                                    align="middle"
                                    style={{
                                        backgroundImage: `linear-gradient(to right, ${permissionData?.property_json?.background_color1}, #ffffff,${permissionData?.property_json?.background_color2})`, padding: '10px',
                                        position: 'relative',
                                    }}>
                                    <Col style={{ textAlign: 'center' }}>
                                        {console.log(permissionData)}
                                        <span style={{
                                            fontSize: permissionData?.property_json?.size ? permissionData.property_json.size : "3vmin",
                                            fontWeight: permissionData?.property_json?.blod ? 900 : "normal",
                                            fontStyle: permissionData?.property_json?.italic ? "italic" : "normal",
                                            textDecoration: permissionData?.property_json?.textDecoration ? "underline" : "none"
                                        }}>
                                            {permissionData.name}
                                            </span>
                                    </Col>
                                    {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                                                                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                                                                        </Col> */}
                                </Row>
                            </Col>
                            {/* 副標題 */}
                            {/* <Col span={24}>
                                <Row gutter={[40, 16]} justify="center" align="middle" style={{ margin: '10px' }}>
                                    <Col md={{ span: 6 }} sm={{ span: 24 }}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                                        </Row>
                                    </Col>
                                    <Col md={{ span: 8 }} sm={{ span: 24 }} >
                                        <Row justify={'center'}>
                                            <Col >
                                                <span dangerouslySetInnerHTML={{ __html: permissionData.subheading }}></span>
                                            </Col>
                                        </Row>

                                    </Col>
                                    <Col md={{ span: 6 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                                        <Row gutter={[8, 8]}>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                            <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col> */}
                        </>}

                        {/* <Col span={24}>
                            {marquee_color && <>
                                <Marquee style={{ height: '2em', backgroundColor: `rgba(${marquee_color.r}, ${marquee_color.g}, ${marquee_color.b}, ${marquee_color.a})`, fontSize: '2vh' }} speed={marquee_speed}>
                                    <NotificationFilled />{marquee_text}
                                </Marquee>
                            </>}
                            <Carousel_news_ticker
                                height={'20vh'}
                            />
                        </Col> */}
                        {/* {console.log(pageContainerData)} */}
                        {
                            pageContainerData && pageContainerData?.map((rowData, rowIndex) => {
                                return (
                                    rowData?.permission_frontend_row_data?.map((columnData, columnIndex) => {
                                        return (
                                            columnData?.frontend_row_frontend_column_data?.map((componentData, componentIndex) => {
                                                return (
                                                    <Col span={24}>
                                                        <Row>
                                                            <Col span={24}>
                                                                {/* <Row gutter={[10, 20]} justify="space-around"> */}
                                                                {componentRender(componentData.frontend_component_name, componentData.frontend_column_frontend_component_blog_type_data)}
                                                                {/* </Row> */}
                                                            </Col>
                                                        </Row>
                                                    </Col>

                                                )
                                            })
                                        )

                                    })
                                )
                            })
                        }
                    </Row>
                    {/* </EMILayout> */}
                </>
            }
        </>
    )
}
export default MainPage;